import styles from './WeChatDetails.module.scss';
import CompletionModalWindow from '@components/modals/CompletionModalWindow';
import WarningIcon from '@assets/icons/warning_62.svg';
import WeChatAddModalWindow from '../../modals/WeChatAddModalWindow/WeChatAddModalWindow';
import WeChatDeleteModalWindow from './../../modals/WeChatDeleteModalWindow';
import WeChatInformer from '@components/WeChatInformer';
import WeChatWallet from './../../components/WeChatWallet/WeChatWallet';
import WrapperDetails from '../WrapperDetails';
import { IWeChatDetailsProps, TWeChatCredentials } from './../../types';
import { Loader } from '@components/Loader';
import { Modal } from '@components/Modal';
import { useProfile } from '@contexts/ProfileContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const WeChatDetails: React.FC<IWeChatDetailsProps> = (props: IWeChatDetailsProps): React.ReactElement => {
  const { refetchWallets } = props;

  const [addedWeChat, setAddedWeChat] = useState<TWeChatCredentials | undefined>(undefined);
  const [isOpenWeChatAddWindow, setIsOpenWeChatAddWindow] = useState<boolean>(false);
  const [isOpenWeChatDeleteWindow, setIsOpenWeChatDeleteWindow] = useState<boolean>(false);
  const [isOpenWeChatWarningWindow, setIsOpenWeChatWarningWindow] = useState<boolean>(false);

  const { account, get } = useProfile();
  const { t } = useTranslation();

  const weChatDelete = (): void => {
    if (account?.email) {
      setIsOpenWeChatDeleteWindow(true);
    } else {
      setIsOpenWeChatWarningWindow(true);
    }
  };

  return (
      <>
        <WrapperDetails
            btnAction={() => {
            }}
            btnText={t('profileData.buttonChange')}
            isActionVisible={false}
            title={t('profileData.weChatAccountLogin')}
        >
          {account ? (
              <>
                {account.weChatLogin ? (
                    <div className={styles.users}>
                      <WeChatWallet
                          actions={[
                            {
                              self: weChatDelete,
                              type: 'delete'
                            }
                          ]}
                          phone={account.weChatLogin.phone}
                      />
                    </div>
                ) : (
                    <div className={styles.informer}>
                      <WeChatInformer
                          action={(data: TWeChatCredentials) => {
                            setAddedWeChat(data);
                            setIsOpenWeChatAddWindow(true);
                          }}
                          calledFrom="linktologin"
                          informerDescription={t('profileData.weChatInformer.description')}
                          informerTitle={t('profileData.weChatInformer.title')}
                          refetchWallets={refetchWallets}
                      />
                    </div>
                )}
              </>
          ) : (
              <Loader
                  dark
                  size="xs"
              />
          )}
        </WrapperDetails>
        <Modal
            isOpen={isOpenWeChatAddWindow}
            onClickOverlay={() => setIsOpenWeChatAddWindow(false)}
            onClose={() => setIsOpenWeChatAddWindow(false)}
        >
          <WeChatAddModalWindow
              addedWeChat={addedWeChat!}
              handlerSetIsOpenWeChatAddWindow={setIsOpenWeChatAddWindow}
              refetchUseProfile={get}
          />
        </Modal>
        <Modal
            isOpen={isOpenWeChatDeleteWindow}
            onClickOverlay={() => setIsOpenWeChatDeleteWindow(false)}
            onClose={() => setIsOpenWeChatDeleteWindow(false)}
        >
          <WeChatDeleteModalWindow
              handlerSetIsOpenWeChatDeleteWindow={setIsOpenWeChatDeleteWindow}
              refetchUseProfile={get}
          />
        </Modal>
        <Modal
            isOpen={isOpenWeChatWarningWindow}
            onClickOverlay={() => setIsOpenWeChatWarningWindow(false)}
            onClose={() => setIsOpenWeChatWarningWindow(false)}
        >
          <CompletionModalWindow
              btnText={t('profileData.weChatWarningModal.btnText')}
              description={t('profileData.weChatWarningModal.description')}
              handlerSetIsOpenModalWindow={() => setIsOpenWeChatWarningWindow(false)}
              icon={WarningIcon}
              title={t('profileData.weChatWarningModal.title')}
          />
        </Modal>
      </>
  );
};

export default WeChatDetails;
